import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE_NAME = 'student';

const StudentService = {
  getListYear() {
    return Http.get(`/${RESOURCE_NAME}/years/list`);
  },
  getPagedResult() {
    return Http.get(`/${RESOURCE_NAME}`);
  },
  getList() {
    return Http.get(`/${RESOURCE_NAME}/list`);
  },
  create() {
    return Http.post(`/${RESOURCE_NAME}`);
  },
  del(id) {
    return Http.delete(`/${RESOURCE_NAME}/${id}`);
  },
  getChannel() {
    return Http.get(`/${RESOURCE_NAME}/channel-exist`);
  }
};

export default StudentService;
